
import { observable, action, runInAction } from 'mobx';
import { message } from 'antd';
import Echarts from "echarts";
import { sum } from '@/method';
import axios from '@/method/axios';

class store {
    @observable data = [];
    @observable criticismData = [];
    @observable loading = false;

    getData = async (name = '') => {
        try {
            runInAction(() => {
                this.loading = true;
            });
            const user = JSON.parse(sessionStorage.getItem('user')) || {};
            let res = await axios.get(`/ota/keywordsnum?sys_id=${user['comid']}&name=${name}`);
            let data = res.data || [];
            data = data.sort((a, b) => b.num - a.num);

            this.setChart(data);
            runInAction(() => {
                this.data = data;
                this.loading = false;
            });

        } catch (error) {
            console.error(error);
            message.error('数据获取错误！');
            runInAction(() => {
                this.loading = false;
            });
        }
    }

    getCriticism = async (content, name = '') => {
        try {
            runInAction(() => {
                this.loading = true;
            });
            const user = JSON.parse(sessionStorage.getItem('user')) || {};
            const url = `sys_id=${user['comid']}&content=${content}&score=3.0&name=${name}`;
            let res = await fetch(`/index/comment/criticism?${url}`, { credentials: 'include' });
            let data = await res.json();
            runInAction(() => {
                this.criticismData = data;
                this.loading = false;
            });

        } catch (error) {
            console.error(error);
            message.error('数据获取错误！');
            runInAction(() => {
                this.loading = false;
            });
        }
    }

    setChart = (data, isOnResize) => {
        const myChart = Echarts.init(document.getElementById('chart'));
        const listName = {
            '早餐': "Breakfast",
            '周边环境': "Environment",
            '位置': "Location",
            '交通': "Transportation",
            '卫生': "Clean",
            '房间环境': "Rooms",
            '服务': "Service",
        };
        myChart.resize();
        if (isOnResize) {
            return
        }
        // 指定图表的配置项和数据
        /*
        *   data1 差评
        *   data2 好评
        *   data3 总和
        */
        const data1 = data.map(x => x.num);
        const data2 = data.map(x => x.num2);
        const data3 = data.map(x => sum([x.num2, x.num], 0));

        const datacity = data.map(x => `${x.name} ${listName[x.name]}`);
        const option = {
            color: ['#2E75B6', '#9DC3E6'],
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'shadow'
                }
            },
            toolbox: {
                show: true,
            },
            legend: {
                bottom: '8%',
                data: ['表扬 Positive', '批评 Negative'],
                itemGap: 112,
                itemWidth: 16,
                itemHeight: 16,
            },
            grid: { //图表的位置
                top: '14%',
                left: '3%',
                right: '4%',
                bottom: '20%',
                containLabel: true
            },
            yAxis: [{
                type: 'value',
                max: Math.max(...data3),
                axisLabel: {
                    show: true,
                    interval: 'auto',
                    formatter: '{value} '
                },
                splitLine: {
                    show: true,
                    lineStyle: {
                        type: 'solid',
                        color: '#D8D8D8'
                    }
                },
                axisLine: {
                    show: false,
                    lineStyle: {
                        color: "rgba(102,102,102,0.5);"
                    },
                },
                show: true

            }],
            xAxis: [{
                type: 'category',
                axisLabel: {
                    interval: 0,
                    show: true,
                    splitNumber: 15,
                    textStyle: {
                        fontSize: 12,
                        color: '#666666'
                    },

                },
                data: datacity,
            }],
            series: [{
                name: '表扬 Positive',
                type: 'bar',
                stack: 'sum',
                barWidth: '32px',
                data: data2,
            }, {
                name: '批评 Negative',
                type: 'bar',
                barWidth: '32px',
                stack: 'sum',
                data: data1,
                label: {
                    normal: {
                        // offset: ['50', '100'],
                        show: true,
                        position: 'top',
                        formatter: '{c}',
                        textStyle: {
                            color: '#333',
                            fontSize: 16
                        }
                    }
                },

            },
            {
                name: '总数',
                type: 'bar',
                stack: 'sum',
                itemStyle: {
                    normal: {
                        color: 'rgba(128, 128, 128, 0)'
                    }
                },
                data: data3
            }
            ]
        };
        myChart.setOption(option);
    }
}

const revenue = new store();

export default revenue;


// WEBPACK FOOTER //
// ./src/store/online/criticism.js